import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconEventEndStyle0 = cosmosIconCss;

const CosmosIconEventEnd$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconEventEnd extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '569775c73d1a39add3c0edb5fb576884c48fcee9', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '02228581239ba299bb73ec7c514407481c8a20d0', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b8bb570018d3ba5126d8cfad6841a334352cc881', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.506 9.5a6.504 6.504 0 0 1 6.487-6 6.503 6.503 0 0 1 6.506 6.5c0 3.59-2.913 6.5-6.506 6.5H8.677l.004-2.284a.4.4 0 0 0-.69-.29l-3.004 3a.4.4 0 0 0 0 .56l3.003 3a.4.4 0 0 0 .68-.29L8.675 18h2.319C15.415 18 19 14.418 19 10s-3.585-8-8.007-8A8.005 8.005 0 0 0 3 9.5c-.017.276.209.5.485.5h.5a.532.532 0 0 0 .52-.5Zm6.744-1.509v2.557l1.59 1.789a.495.495 0 0 1 0 .698l-.38.324a.506.506 0 0 1-.7 0l-1.88-2.094a.448.448 0 0 1-.13-.324V7.99c0-.271.224-.491.5-.491h.5c.276 0 .5.22.5.491Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconEventEndStyle0; }
}, [1, "cosmos-icon-event-end", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-event-end"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-event-end":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconEventEnd$1);
            }
            break;
    } });
}

const CosmosIconEventEnd = CosmosIconEventEnd$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconEventEnd, defineCustomElement };
